import { Controller, Module } from "@nestjs/common";
import { TypeOrmModule } from "@nestjs/typeorm";
import { AssetCheckList } from "./dto/checklist.entity";
import { AssetChecklistDto } from "./dto/checklist.dto";
import { AssetChecklistController } from "./checklist.controller";
import { ApplicationExceptionHandler } from "@gtpl/shared-utils/error-messages";
import { AssetChecklistAdapter } from "./dto/checklist.adapter";
import { AssetChecklistService } from "./checklist.service";
import { AssetCheckListRepository } from "./dto/checklist.repository";

@Module({
    imports:[TypeOrmModule.forFeature([AssetCheckList,AssetCheckListRepository]),],
    controllers:[AssetChecklistController],
    providers :[AssetChecklistService,AssetChecklistAdapter,ApplicationExceptionHandler],
    exports:[AssetChecklistService]
}

)
export class AssetChecklistModule{}